export const exhibitorApi = {
  /* space requirement-------------- */
  GET_ALL_FAIR_STALL: '/api/fair/stall',
  GET_APPLIED_STALL_LIST: '/api/fair/exhibitor/apply-stall',
  DELETE_APPLIED_STALL_LIST: '/api/fair/exhibitor/apply-stall',
  CREATE_SPACE_FOR_STALL: '/api/fair/exhibitor/apply-stall',

  GET_EXHIBITOR_INVOICE_LIST: '/api/fair/exhibitor/invoice-list',
  GET_EXHIBITOR_SINGLE_INVOICE: '/api/fair/exhibitor/invoice-list/',
  GET_EXHIBITOR_BY_SEARCH: '/api/fair/exhibitor/member-list',
  GET_ALL_EXHIBITOR_LIST: '/api/fair/exhibitor/list',
  /* product and service------- */
  GET_ALL_PRODUCT_AND_SERVICE_LIST: `/api/fair/get/all/fair-member-product/by/all`,
  DELETE_PRODUCT_AND_SERVICE_LIST: '/api/fair/delete/fair-member-product',
  ADD_PRODUCT_AND_SERVICE_LIST: `/api/fair/add-product/into-fair-member`,
  /* additional service------- */
  ADDITIONAL_SERVICE_LIST: `/api/exhibitor/additional`,
  DELETE_ADDITIONAL_SERVICE_LIST: '/api/exhibitor/additional',
  ADD_ADDITIONAL_SERVICE_LIST: `/api/exhibitor/additional`,
  GET_ADDITIONAL_SERVICES: `/api/exhibitor/additional/list`,
  /* profile-------------------- */
  GET_EXHIBITOR_PROFILE: `/api/auth/fair-member/profile`,
};
